import React from 'react';
import { Tag } from 'antd';
import { getLabelValue } from '../lib/util';

type Props = {
  annotationTypes: string[];
};
export const LabelGroup = ({ annotationTypes }: Props) => {
  return (
    <div style={{ marginTop: '30px', marginBottom: '30px' }}>
      {annotationTypes.map((label, index) => {
        return (
          <Tag
            key={index}
            style={{
              padding: '10px',
              marginBottom: '10px',
              backgroundColor: '#F7F7F7',
              borderColor: '#EBEBEB',
            }}>
            <span style={{ color: '#7E7F87', margin: '5px', fontSize: '14px' }}>{getLabelValue(label)}</span>
          </Tag>
        );
      })}
    </div>
  );
};
